import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-05-30
 * @brief SEI 오늘의 점검 팝업
 *
 ********************************************************************/
import { useEffect, useState } from "react";
//recoil
import { useRecoilState, useSetRecoilState } from "recoil";
import { alertState, noneUrl } from "../../../recoil/assessmentState";
import { reloadAlert } from "../../../recoil/userState";
// utils
import { useNavigate } from "react-router-dom";
import { urlState } from "../../../recoil/menuState";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
function AlertPop(props) {
    //
    const navigate = useNavigate();
    const t = useTrans();
    //
    const [alert, setAlert] = useRecoilState(alertState);
    const setReloadAlerts = useSetRecoilState(reloadAlert);
    const setRecoilUrlInfo = useSetRecoilState(urlState);
    const setRecoilNoneUrlInfo = useSetRecoilState(noneUrl);
    //  body
    const popBody = props.popBody;
    const [alertB, setAlertB] = useState(false);
    useEffect(() => {
        if (alertB) {
            setAlert({
                header: "",
                layerId: "",
                type: "",
                divTag: "",
                pTag: {
                    p1: "",
                    p2: "",
                },
                callBack: null,
                callBackName: "",
            });
            setAlertB(false);
            setReloadAlerts(false);
        }
    }, [alertB]);
    function close(id, blooean) {
        if (alert.callBack == null) {
            AlertClose(id, blooean);
        }
        else {
            alert.callBack();
            if (alert.layerId !== "false") {
                AlertClose(id, blooean);
            }
        }
    }
    function AlertClose(id, blooean) {
        // type == innert 완료 일때
        if (alert.type == CONST.TYPE_INNRE) {
            CUTIL.jsclose_InnerPopup(id, alert.layerId);
            CUTIL.jsclose_Popup(alert.layerId);
        }
        else if (alert.type == CONST.TYPE_ERROR) {
            // type error 일때
            if (alert.layerId) {
                CUTIL.jsclose_InnerPopup(id, alert.layerId);
            }
            else {
                CUTIL.jsclose_Popup(id);
            }
        }
        else {
            //그외
            CUTIL.jsclose_Popup(id);
            if (alert.layerId) {
                CUTIL.jsclose_Popup(alert.layerId);
            }
        }
        if (alert.layerId == "pop-report") {
            setReloadAlerts(true);
        }
        else if (alert.layerId == CONST.POP_RELOAD) {
            window.location.reload();
        }
        else if (alert.layerId == "reset") {
            setRecoilNoneUrlInfo(false);
            setRecoilUrlInfo(CONST.URL_OPERATION);
            navigate(CONST.URL_OPERATION);
        }
        setAlertB(blooean);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ id: "pop-alert", className: `popup-layer js-layer ${!alertB ? "hidden" : ""} popup-basic inner-popup` }, { children: [_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: alert.header ? alert.header : "Alert" }), _jsx("button", Object.assign({ className: "btn btn-close ", onClick: (e) => close("pop-alert", true) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] })), _jsxs("div", Object.assign({ className: "popup__body" }, { children: [alert.divTag && _jsx("p", Object.assign({ style: { whiteSpace: "pre-line" } }, { children: alert.divTag })), alert.pTag && (_jsxs(_Fragment, { children: [_jsx("p", { children: alert.pTag.p1 }), _jsx("p", { children: alert.pTag.p2 })] }))] })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "", onClick: (e) => close("pop-alert", true) }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] })) }));
}
export default AlertPop;
